<template>
  <div class="relative w-screen h-screen overflow-hidden lg:flex">
    <!-- Mobile Header -->
    <div class="relative z-20 flex items-center justify-between bg-black lg:hidden">
      <img src="../assets/img/logo-light.svg" class="h-8 ml-3">
      <button class="top-0 right-0 z-50 flex items-center justify-center text-white rounded-r w-14 h-14 lg:hidden" @click="open = !open">
        <menu-icon :open="open" />
      </button>
    </div>

    <!-- Overlay -->
    <button v-if="open" @click="open = false" class="fixed inset-0 z-10 w-screen h-screen"></button>

    <!-- Nav -->
    <div class="absolute top-0 z-50 flex flex-col flex-none w-64 h-screen transition duration-300 ease-out transform bg-black shadow-lg lg:max-h-screen lg:sticky lg:top-0 lg:transform-none" :class="{ 'translate-x-0': open, '-translate-x-full': !open }">
      <div class="px-1 py-3 lg:hidden">
        <img src="../assets/img/logo-light.svg" class="h-8 ml-3">
      </div>
      <dashboard-nav class="flex-grow" :open="open" />
    </div>
    
    <!-- View -->
    <div class="flex-grow w-full h-full overflow-y-auto" :class="{ 'open': open }">
      <router-view :key="account.subdomain" />
    </div>
  </div>
</template>

<script>
import DashboardNav from '@/components/DashboardNav'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'Dashboard',

  metaInfo () {
    const accountName = this.account.name
    return {
      title: 'Dashboard',
      titleTemplate: `%s | ${accountName}`
    }
  },

  components: {
    DashboardNav
  },

  computed: {
    ...mapState(['subdomain']),
    ...mapGetters(['account'])
  },

  created () {
    // Redirect to a product page if we are on base dashboard route
    if (this.$route.name === 'Dashboard') {
      if (this.account && this.account.subscription) {
        if (this.account.subscription.orders) {
          this.$router.push({ name: 'OrderList' })
        } else if (this.account.subscription.automations) {
          this.$router.push({ name: 'AutomationList' })
        } else if (this.account.subscription.records) {
          this.$router.push({ name: 'RecordList' })
        }
      }
    }
  },

  data () {
    return {
      open: false
    }
  },

  /**
   * Router gaurds ensure that there is a subdomain
   * present in the :account parameter
   */
  beforeRouteEnter (to, from, next) {
    if (!to.params.account) {
      next(vm => {
        let subdomain = from.params.account || vm.account.subdomain
        vm.$router.push({ name: to.name, params: { account: subdomain } })
      })
    } else {
      next()
    }
  },

  beforeRouteUpdate (to, from, next) {
    if (!to.params.account) {
      // If there is no account on the to route
      // Fallback to the from, or the calculated account subdomain, or the state subdomain
      let subdomain = from.params.account || this.account.subdomain || this.subdomain
      next({ name: to.name, params: { account: subdomain} })
    } else {
      next()
    }
  }
}
</script>